/**
 * @typedef {(typeof PaymentChannelIDEnum)[keyof typeof PaymentChannelIDEnum]} PaymentChannelIDEnumValue
 */

const PaymentChannelIDEnum = Object.freeze({
    FRONTEND: 1,
    BACKEND: 3,
    EPOS: 4,
    TRADE_PORTAL: 5,
    EXPERIENCE_BANK: 6,
    AUTOMATIC_RENEWALS: 8,
    PRO_KIOSK: 9,
    API: 10,
    PRO_MENU: 11,
});

module.exports = PaymentChannelIDEnum;
